import {
  GOOGLE_ONE_TAP_MODAL_SHOWN,
  GOOGLE_ONE_TAP_LOGGED_IN,
  GOOGLE_SIGN_IN_SHOWN,
  GOOGLE_SIGN_IN_LOGGED_IN,
} from '../constants/reportableEventConstants';
import reporter from '../reporter';

async function reportGoogleOneTapModalShown() {
  reporter.report(GOOGLE_ONE_TAP_MODAL_SHOWN, {});
}

async function reportGoogleOneTapLoggedIn() {
  reporter.report(GOOGLE_ONE_TAP_LOGGED_IN, {});
}

async function reportGoogleSignInShown() {
  reporter.report(GOOGLE_SIGN_IN_SHOWN, {});
}

async function reportGoogleSignInLoggedIn() {
  reporter.report(GOOGLE_SIGN_IN_LOGGED_IN, {});
}

export {
  reportGoogleOneTapModalShown,
  reportGoogleOneTapLoggedIn,
  reportGoogleSignInShown,
  reportGoogleSignInLoggedIn,
};

export default {
  reportGoogleOneTapModalShown,
  reportGoogleOneTapLoggedIn,
  reportGoogleSignInShown,
  reportGoogleSignInLoggedIn,
};
